import { FC } from 'react';
import styled from 'styled-components';

import { LIVE_CHAT_TEST_IDS } from '../lib/testIds';
import CONTENT from './content.json';

const AgentTypingWrapper = styled.div`
  text-align: center;
  font-style: italic;
  margin-bottom: 16px;
`;

export const AgentTyping: FC = () => {
  return (
    <AgentTypingWrapper data-testid={LIVE_CHAT_TEST_IDS.AGENT_TYPING}>{CONTENT.chat.agent.typing}</AgentTypingWrapper>
  );
};

AgentTyping.displayName = 'AgentTyping';
